import { MeetingType } from './meeting-type.model';

export class WardMeeting {
    campusWardMeetingId: number;
    campusWardId: number;
    meetingType: MeetingType;
    time: string;
    location: string;
    sortOrder?: number;
}
